import '../textFieldItemStyle.scss';

function InputAnswer({ data, updateField }) {
  return (
    <div className="textFieldItemStyle">
      <input
        className="label-input"
        placeholder="Type a question..."
        value={data.label}
        onChange={(e) => updateField(e.target.value, 'label')}
        style={{
          textAlign: data.labelAlign,
        }}
      />
      <div className="drag-input-container">
        <div className="input-cover"></div>
        <input
          id={`input-answer-${data.added}`}
          type="text"
          name={`input-answer-${data.added}`}
          aria-describedby={`description-${data.added}`}
          placeholder={data.placeholder}
        />
      </div>
      <input
        className="sublabel-input"
        placeholder="Add some help text..."
        value={data.subLabel}
        onChange={(e) => updateField(e.target.value, 'subLabel')}
        style={{
          textAlign: data.subLabelAlign,
        }}
      />
    </div>
  );
}

export default InputAnswer;
